export default __webpack_public_path__ + "static/media/promote-icon.3fb41d5f.svg";